import React from 'react';

import { genExternalLinkHandler } from 'shared/helpers/linking';
import { cn } from 'shared/lib/utils';

type SmsOptInFinePrintProps = {
  variant?: 'checkbox' | 'nudge' | 'legacy';
  className?: string;
};

const FinePrintLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <a
    href={href}
    onClick={genExternalLinkHandler(true)}
    className="font-bold text-inherit underline"
  >
    {children}
  </a>
);

const finePrintBody = {
  checkbox:
    'By checking this box, you agree to receive recurring automated texts from Incredible Health about job matches and interview requests at the number provided. Consent isn’t a condition of using Incredible Health. Message frequency varies. Message and data rates may apply. Reply STOP to cancel, HELP for help. We never sell or share your number.',
  nudge:
    'By tapping “Turn on text alerts”, you agree to receive recurring automated texts from Incredible Health about job matches and interview requests at the number you provided. Consent isn’t a condition of use. Message frequency varies. Message and data rates may apply. Reply STOP to cancel, HELP for help.',
};

export const SmsOptInFinePrint = ({
  variant = 'checkbox',
  className = undefined,
}: SmsOptInFinePrintProps) => (
  <div
    data-slot="sms-opt-in-fine-print"
    className={cn(
      'text-center text-paragraph-xs text-gray-placeholder',
      className
    )}
  >
    {variant === 'legacy' ? (
      <>
        View our{' '}
        <FinePrintLink href="https://www.incrediblehealth.com/privacy/">
          privacy policy
        </FinePrintLink>{' '}
        and{' '}
        <FinePrintLink href="https://www.incrediblehealth.com/terms/">
          terms
        </FinePrintLink>
        . Incredible Health will send you messages related to your job search.
        Message and data rates may apply. Reply HELP for help or STOP to cancel
        at any time.
      </>
    ) : (
      <>
        {finePrintBody[variant]}{' '}
        <FinePrintLink href="https://www.incrediblehealth.com/privacy/">
          Privacy Policy
        </FinePrintLink>{' '}
        &middot;{' '}
        <FinePrintLink href="https://www.incrediblehealth.com/terms/">
          Terms
        </FinePrintLink>
      </>
    )}
  </div>
);
